// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1osq{width:100%}
._1e02idpf{inset-inline-start:0}
._jqf61a21{label:requiredInput}
._kqswstnw{position:absolute}
._lcxvglyw{pointer-events:none}
._rjxpidpf{inset-inline-end:0}
._tzy4idpf{opacity:0}
._u7coidpf{inset-block-end:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/react-select/dist/esm/compiled/components/internal/required-input.compiled.css"],"names":[],"mappings":"AAAA,WAAW,UAAU;AACrB,WAAW,oBAAoB;AAC/B,WAAW,mBAAmB;AAC9B,WAAW,iBAAiB;AAC5B,WAAW,mBAAmB;AAC9B,WAAW,kBAAkB;AAC7B,WAAW,SAAS;AACpB,WAAW,iBAAiB","sourcesContent":["._1bsb1osq{width:100%}\n._1e02idpf{inset-inline-start:0}\n._jqf61a21{label:requiredInput}\n._kqswstnw{position:absolute}\n._lcxvglyw{pointer-events:none}\n._rjxpidpf{inset-inline-end:0}\n._tzy4idpf{opacity:0}\n._u7coidpf{inset-block-end:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
